/**
 * New Angular Http Client Interceptor to being able to listen to each call
 * This replaces the old #HttpInterceptor.
 */
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { NgProgress, NgProgressRef } from '@ngx-progressbar/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { cache, CacheSignature } from '../services/cache';

Observable.prototype['cache'] = cache;

declare module 'rxjs/Observable' {
  interface Observable<T> {
    cache: CacheSignature<T>;
  }
}

export class HttpRequestInterceptor implements HttpInterceptor {
  protected progressRef: NgProgressRef;

  constructor(
    private toastrService: ToastrService,
    protected progressService: NgProgress
  ) {
    this.progressRef = progressService.ref();
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token = localStorage.getItem('token');
    const authReq = request.clone({
      setHeaders: { Authorization: `Bearer ${token}`, observe: 'response' }
    });
    return next.handle(authReq).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          // Detects if the user has been rejected do time Session expiration
          /*if (event.headers.get('x-login-url')) {
							window.location.href = event.headers.get('x-login-url');
						}*/
        }
        return event;
      }),
      catchError((err: HttpErrorResponse) => {
        let error = err.error;
        console.error(error);
        if (err.statusText && error.message) {
          let message = error.message;
          this.toastrService.error(`${message}\n${err.statusText}`);
          if (this.progressRef) {
            this.progressRef.complete();
          }
        }
        return throwError(err);
      })
    );
  }
}
